import React from 'react'
import { withRouter } from 'react-router-dom'
import { formatPrice } from 'utils/currency'
import { ButtonSection, OrderNumber, Price } from './styled'
import ViewOrderPortal from './ViewOrderPortal'

const ViewOrder = props => {
  const { orderQuantity, orderPrice, history, match } = props

  const goToOrder = () => {
    history.push(`/order/${match.params.id}/review`)
  }

  return (
    <ViewOrderPortal>
      <ButtonSection onClick={goToOrder}>
        <OrderNumber small color="teal">
          <span>{orderQuantity}</span>
        </OrderNumber>
        <div>Go to checkout</div>
        <Price>{formatPrice(orderPrice)}</Price>
      </ButtonSection>
    </ViewOrderPortal>
  )
}

export default withRouter(ViewOrder)
